import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const legalLinks = [
    // { labelKey: "footer.nosotros", to: "/nosotros" },
    // { labelKey: "footer.ia", to: "/servicios/inteligencia-artificial" },
    // { labelKey: "footer.iaAviacion", to: "/ia-aviacion-seguridad-operacional" },
    // { labelKey: "footer.proyectos", to: "/proyectos" },
    { labelKey: "footer.privacidad", to: "/politica-privacidad" },
    { labelKey: "footer.datos", to: "/politica-datos" },
];

const externalLinks = [
    // { label: "Nuestras páginas web", href: "https://webpages.emmpieza.com/" },
    //{ label: "App en Google Play", href: "https://play.google.com/store/apps/details?id=com.emmpieza.tunegocioonline" },
];

function Footer() {
    const { t } = useTranslation();
    const footerRef = useRef(null);

    // El footer es fijo (como el navbar): se mide su alto real y se expone
    // como variable CSS para que cada página reserve el espacio exacto
    // (padding-bottom) y no quede tapada, sin importar si el texto envuelve
    // a una o dos líneas según el ancho de pantalla.
    useEffect(() => {
        const el = footerRef.current;
        if (!el) return;
        const updateHeight = () => {
            document.documentElement.style.setProperty(
                "--em-footer-h",
                `${el.offsetHeight}px`,
            );
        };
        updateHeight();
        const observer = new ResizeObserver(updateHeight);
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    return (
        <footer ref={footerRef} className="footer-shell text-em-soft">
            <div className="mx-auto flex max-w-5xl flex-col items-center justify-center gap-1.5 px-6 py-3 sm:flex-row sm:gap-6 sm:px-8">
                <p className="text-center text-xs text-em-muted sm:text-sm">
                    {t("footer.copy", { year: new Date().getFullYear() })}
                </p>

                <nav
                    className="flex flex-wrap justify-center gap-x-5 gap-y-1 text-xs font-normal tracking-wide"
                    aria-label={t("footer.enlacesAria")}
                >
                    {legalLinks.map(({ labelKey, to }) => (
                        <Link
                            key={labelKey}
                            to={to}
                            className="text-em-soft transition-colors hover:text-em-accent focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-em-accent"
                        >
                            {t(labelKey)}
                        </Link>
                    ))}
                    {externalLinks.map(({ label, href }) => (
                        <a
                            key={label}
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-em-soft transition-colors hover:text-em-accent focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-em-accent"
                        >
                            {label}
                        </a>
                    ))}
                </nav>
                {/* <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/LinkedIn_icon.svg/3840px-LinkedIn_icon.svg.png" alt="LinkedIn" className="w-5 h-5" /> */}
            </div>
        </footer>
    );
}

export default Footer;
